import { CurrencyType } from './types/CurrencyTypes';

function convertNumberToFinancialString(number, currency) {
  let numberToConvert = number || 0;
  if (typeof numberToConvert === 'string') {
    numberToConvert = parseFloat(number);
  }
  // will seperate thousands with comma,
  //  ensure western locale, and will enforce two trailing decimal places
  const structuredString = numberToConvert.toLocaleString('en-US', {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  });
    // if no currency provided default will be dollars
  let currencySymbol = '$';
  if (currency) {
    currencySymbol = currency === CurrencyType.EUR ? '\u20AC' : '$';
  }
  return `${currencySymbol}${structuredString}`;
}

export default convertNumberToFinancialString;
